import { createGTMEcommerceEvent, mapTrackingCommerceToGTMEcommerce } from '../../core/ecommerceMapper';
import { normalizeSegment } from '../../core/normalizers';
import { mapGTMUserData } from '../../core/user';
import type { GTMEcommerce } from '../../types';
import { GTMOrderType } from '../../types';
import { mapPublicServicePlanLeadModalToTrackingCommerce } from '../plans/publicServicePlans';
import {
    mapPlanChangeLeadModalToTrackingCommerce,
    mapServicePlanLeadModalToTrackingCommerce,
} from '../plans/servicePlans';
import type { LeadFormEventData, LeadFormTrackingContext } from './types';

const EQUIPMENT_PATH_PREFIXES = ['/prekes', '/verslui/prekes'];
const OTHER_PATH_PREFIXES = ['/privatiems/pagalba', '/verslui/pagalba'];

export const mapLeadFormTrackingContextToGTMEcommerce = (
    tracking?: LeadFormTrackingContext,
): GTMEcommerce | undefined => {
    if (!tracking) {
        return undefined;
    }

    switch (tracking.source) {
        case 'servicePlanLeadModal':
            return mapTrackingCommerceToGTMEcommerce(mapServicePlanLeadModalToTrackingCommerce(tracking.data));
        case 'publicServicePlanLeadModal':
            return mapTrackingCommerceToGTMEcommerce(
                mapPublicServicePlanLeadModalToTrackingCommerce(tracking.data.plan, tracking.data.index),
            );
        case 'planChangeLeadModal':
            return mapTrackingCommerceToGTMEcommerce(mapPlanChangeLeadModalToTrackingCommerce(tracking.data));
        default:
            return undefined;
    }
};

export const createLeadFormGAEvent = (data: LeadFormEventData) => {
    const user = mapGTMUserData(data.userData);
    const pathname = (data.pathname ?? (typeof window === 'undefined' ? '' : window.location.pathname)).toLowerCase();
    const orderType =
        (EQUIPMENT_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix)) && GTMOrderType.Equipment) ||
        (OTHER_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix)) && 'Other') ||
        GTMOrderType.Services;

    return createGTMEcommerceEvent(
        data.event,
        {
            orderType,
            segment: normalizeSegment(data.segment),
            additionalProperties: {
                ...data.modalEcommerce,
                ...mapLeadFormTrackingContextToGTMEcommerce(data.tracking),
            },
        },
        {
            user_id: user.user_id,
            email: data.email || user.email,
            phone: data.phone || user.phone,
        },
    );
};
